import { pushEvent } from './dataLayer';

/**
 * Engagement events - search, forms, and the b2b events on my pages.
 * The functions are called directly from the components that own the
 * interaction, so the event is sent when the action actually happens.
 */

export const trackSearch = (searchTerm, numberOfResults, searchType = 'site_search') => {
    if (!searchTerm) {
        return;
    }
    pushEvent('search', {
        search_term: String(searchTerm).toLowerCase(),
        number_of_results: numberOfResults,
        search_type: searchType,
    });
};

export const trackFormSubmit = (formName, extra = {}) =>
    pushEvent('form_submit', { form_name: formName, ...extra });

export const trackOrderHistoryView = (numberOfOrders, showOnlyMyOrders) =>
    pushEvent('view_order_history', {
        number_of_orders: numberOfOrders,
        only_my_orders: !!showOnlyMyOrders,
    });

export const trackReorder = (orderId, clearCart) =>
    pushEvent('reorder_clicked', {
        order_id: orderId,
        replaced_cart: !!clearCart,
    });

export const trackInvoiceDownload = (invoiceId, asFile) =>
    pushEvent('invoice_downloaded', {
        invoice_id: invoiceId,
        download_type: asFile ? 'file' : 'view',
    });

/**
 * Forms that post normally are tracked by marking the form element with
 * data-tracking-form="name" in the view. Ajax forms call trackFormSubmit
 * directly when the post succeeded.
 */
export const initFormTracking = () => {
    document.addEventListener(
        'submit',
        (event) => {
            const form = event.target.closest('[data-tracking-form]');
            if (!form) {
                return;
            }
            trackFormSubmit(form.dataset.trackingForm, {
                form_id: form.id || undefined,
            });
        },
        true
    );
};
